import React, { useCallback } from 'react';
import { useShowBannerController } from 'src/hooks/useShowBannerController';
import { InformationAboutFlightTypes } from './InformationAboutFlightTypes';
import { KEY_COOKIE } from './constants';
import type { InformationAboutFlightTypesPropsType } from './type';
import { handleAnalyticCloseBanner } from './analytics';

export default ({
  className,
}: Pick<
  InformationAboutFlightTypesPropsType,
  'className'
>): JSX.Element | null => {
  const { isShowBanner, handleCloseBanner: handleCloseBannerCookie } =
    useShowBannerController(KEY_COOKIE, 1);

  const handleCloseBanner = useCallback(() => {
    handleCloseBannerCookie();
    handleAnalyticCloseBanner();
  }, [handleCloseBannerCookie]);

  if (!isShowBanner) {
    return null;
  }

  return (
    <InformationAboutFlightTypes
      onClose={handleCloseBanner}
      className={className}
    />
  );
};
